import React from 'react';
import { motion } from 'framer-motion';
import './Sections.css';
import './WhyVtrenderSection.css';

const WhyVtrenderSection = () => {
  const features = [
    {
      icon: 'chart-pie',
      iconSecondary: 'hand-holding-usd',
      title: 'Institutional Intent',
      description: 'See where smart money is positioning in real-time'
    },
    {
      icon: 'layer-group',
      iconSecondary: 'chart-bar',
      title: 'Market Structure',
      description: 'Identify key levels and volume clusters that drive price action'
    },
    {
      icon: 'bolt',
      iconSecondary: 'exchange-alt',
      title: 'Live Auctions',
      description: 'Track order flow imbalances and hidden liquidity pools'
    }
  ];

  return (
    <section className="why-vtrender-section" id="why-vtrender">
      <div className="glow-orb top-left"></div>
      <div className="glow-orb bottom-right"></div>
      
      <div className="container">
        <motion.div className="why-content-full">
          <motion.div 
            className="title-container"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="section-title">
              Not Just Charts. An Intelligence Platform for Market Structure.
            </h2>
            <div className="title-underline"></div>
          </motion.div>
          
          <motion.h3 
            className="section-message"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            You've seen the price. But have you seen what moves price?
          </motion.h3>
          
          <motion.p 
            className="section-description"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            Tools built to track institutional intent, live auctions, and volume shifts — not surface-level noise.
          </motion.p>
          
          <motion.div 
            className="features-grid"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            {features.map((feature, index) => (
              <motion.div 
                key={index}
                className="feature-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 + 0.5 }}
                whileHover={{ y: -10, boxShadow: '0 15px 30px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(58, 134, 255, 0.3)' }}
              >
                <div className="feature-icon-container">
                  <div className="feature-icon">
                    <i className={`fas fa-${feature.icon}`}></i>
                  </div>
                  <div className="feature-icon-secondary">
                    <i className={`fas fa-${feature.iconSecondary}`}></i>
                  </div>
                  <div className="icon-glow"></div>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyVtrenderSection;
